import { apiservice } from "../service";
import { Linking } from "react-native";

export async function authActionLogin(state) {
  try {
    const response = await apiservice({
      path: "/user/login",
      method: "post",
      body: state,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function deleteFinalAth({ state, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/regis/final?id=" + state,
      method: "delete",
      body: "",
      token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function deleteComplete({ body, token }) {
  try {
    const response = await apiservice({
      path: "/competitions/delete",
      method: "delete",
      body,
      token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function deleteEvent({ body, token }) {
  try {
    const response = await apiservice({
      path: "/competitions/opt/components",
      method: "delete",
      body,
      token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function authActionRegister(state) {
  try {
    const response = await apiservice({
      path: "/user/register",
      method: "post",
      body: state,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function authActionPutRegister({ state, token }) {
  try {
    const response = await apiservice({
      path: "/user",
      method: "put",
      body: state,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function authActionCreateCompe(stateCompe, token) {
  try {
    const response = await apiservice({
      path: "/competitions/create",
      method: "post",
      body: stateCompe,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}
export async function authActionPutCompe(stateCompe, token) {
  try {
    const response = await apiservice({
      path: "/competitions/edit",
      method: "put",
      body: stateCompe,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function authActionCreateEvent(AddEventMale, token) {
  try {
    const response = await apiservice({
      path: "/competitions/opt/components",
      method: "post",
      body: AddEventMale,
      token: token.token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}
export async function authActionCreatePrelim(state) {
  try {
    const response = await apiservice({
      path: "/prelimSubmits/createPrelimSubmit",
      method: "post",
      body: state,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

// /api/competitions/

export async function cancelPost(token) {
  try {
    const response = await apiservice({
      path: "/competitions/",
      method: "get",
      body: token,
      // token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getAllcompetitions(token) {
  try {
    const response = await apiservice({
      path: "/competitions/",
      method: "get",
      body: "",
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function createAthlete({ body, token }) {
  try {
    const response = await apiservice({
      path: "/athletes/createAthlete",
      method: "post",
      body,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function editOfficial({ body, token }) {
  try {
    // console.log("state >>", state, token);
    const response = await apiservice({
      path: "/officials",
      method: "put",
      body,
      token,
    });
    // competition_id
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function createOffice({ body, token }) {
  try {
    const response = await apiservice({
      path: "/officials",
      method: "post",
      body,
      token: token,
    });
    console.log("officials ", response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function createFinalAthlete({ body, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/regis/final",
      method: "post",
      body,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getFinalAthlete({ body, body2, token }) {
  try {
    const response = await apiservice({
      path:
        "/approbations/regis/final?competition=" +
        body +
        "&association=" +
        body2,
      method: "get",
      body: "",
      token: token,
    });

    console.log(
      "Arr",
      response,
      "/approbations/regis/final?competition=" + body + "&association=" + body2
    );

    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}
export async function getFinalOffice({ body, token }) {
  try {
    const response = await apiservice({
      path: "/officials/" + body,
      method: "get",
      body: "",
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function competitionsFinalstatus({ body, token }) {
  try {
    const response = await apiservice({
      path: "/competitions/status/",
      method: "post",
      body,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function approbationsregisterform({ body, path, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/registerform/" + body + "?id=" + path,
      method: "get",
      body: "",
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function conditioncheck({ body, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/condition/check",
      method: "post",
      body,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function registerformfinal({ body, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/registerform/final",
      method: "post",
      body,
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getAllcompetitionsyId(token) {
  try {
    const response = await apiservice({
      path: "/competitions/",
      method: "get",
      body: "",
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getcomAthletes({ competition_id, token }) {
  try {
    const response = await apiservice({
      path: `/competitions/status/${competition_id}/athletes`,
      method: "get",
      body: "",
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getAthletes(token) {
  try {
    const response = await apiservice({
      path: "/athletes/getAthletes",
      method: "get",
      body: "",
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function approbationsdeletecheck({ body, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/cancel",
      method: "put",
      body,
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function approbationscheck({ body, token }) {
  try {
    const response = await apiservice({
      path: "/approbations/check",
      method: "post",
      body,
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getAthletesyId({ state, token }) {
  try {
    const response = await apiservice({
      path: "/athletes/getAthlete/" + state,
      method: "get",
      body: "",
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getCompetitionComponents(token) {
  try {
    const response = await apiservice({
      path: "/competitions/opt/components",
      method: "get",
      body: "",
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function deleteUser({ id, token }) {
  try {
    const response = await apiservice({
      path: "/user/" + id,
      method: "delete",
      body: "",
      token: token,
    });
    console.log(response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getApprobations(token) {
  try {
    const response = await apiservice({
      path: "/approbations/getApprobations",
      method: "get",
      body: "",
      token: token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}
// approbations/getApprobations

export async function createApprobation({ state, token }) {
  try {
    console.log("state >>", state, token);
    const response = await apiservice({
      path: "/approbations/registerform/prelim",
      method: "post",
      body: state,
      token,
    });
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function sendmail({ state, token }) {
  try {
    const response = await apiservice({
      path: "/competitions/sendmails",
      method: "post",
      body: state,
      token,
    });
    // competition_id
    console.log("response >>", response);
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getstatus({ state, token }) {
  try {
    console.log("state >>", state, token);
    const response = await apiservice({
      path: "/competitions/status/" + state,
      method: "get",
      body: "",
      token,
    });
    // competition_id
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getSendmail({ state, path, token }) {
  try {
    console.log("state >>", state, token);
    const response = await apiservice({
      path: "/competitions/status/" + path + "/sendmail",
      method: "post",
      body: state,
      token,
    });
    // competition_id
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function getApprobationsCheck({ state, path, token }) {
  try {
    console.log("state >>", state, token);
    const response = await apiservice({
      path: "/approbations/condition/check",
      method: "post",
      body: state,
      token,
    });
    // **association_id**, **competition_id**
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function ChangeApprobations({ state, token }) {
  try {
    console.log("state >>", state, token);
    const response = await apiservice({
      path: "/approbations/createApprobation",
      method: "post",
      body: state,
      token,
    });
    // competition_id
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function editAthlete({ body, token }) {
  try {
    // console.log("state >>", state, token);
    const response = await apiservice({
      path: "/athletes/editAthlete",
      method: "put",
      body,
      token,
    });
    // competition_id
    if (response.status == 200) {
      return response.data;
    } else {
      return false;
    }
  } catch (error) {
    throw error;
  }
}

export async function ExportExcel({
  token,
  competition_id,
  association_id,
  CompeAthlete,
}) {
  try {
    if (competition_id != undefined) {
      if (CompeAthlete) {
        Linking.openURL(
          "http://18.139.99.154:5000/api/competitions/athletes/export?competition_id=" +
            competition_id
        );
      } else {
        Linking.openURL(
          "http://18.139.99.154:5000/api/competitions/status/" +
            competition_id +
            "/export"
        );
      }
    } else if (association_id != undefined) {
      Linking.openURL(
        "http://18.139.99.154:5000/api/competitions/athletes/export?association_id=" +
          association_id
      );
    } else {
      Linking.openURL(
        "http://18.139.99.154:5000/api/competitions/athletes/export"
      );
    }
  } catch (error) {
    throw error;
  }
}
